export enum Language {
	Hebrew = 'he',
	Arabic = 'ar',
}